import gql from 'graphql-tag';
import {mapHitFragments} from '../Hit/Hit';

const mapFragments = {
    SearchResult: gql`
        fragment MapSearchResult on SearchResult {
            mapViewport {
                neLat
                neLong
                swLat
                swLong
            }
            page
            pageSize
            listings {
                ...MapHitListing
            }
            pinnedListing {
                listing {
                    ...MapHitListing
                }
            }
        }
        ${mapHitFragments.Listing}
    `
};

export {mapFragments};
